/* Copyright 2022 SIB Visions GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not
 * use this file except in compliance with the License. You may obtain a copy of
 * the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations under
 * the License.
 */

/** Class for the amount of rows and columns in a GridLayout */
class GridSize{
    /** rows of a grid */
    rows: number
    /** columns of a grid */
    columns: number

    /**
     * @constructor - constructs new gridsize based on the given gridString
     * @param gridString - the data to define the GridSize
     */
    constructor(gridString: Array<string>) {
        this.rows = parseInt(gridString[0]);
        this.columns  = parseInt(gridString[1]);
    }
}
export default GridSize